import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Document, Organization } from '../../shared/sdk';

@Component({
  selector: 'app-list-total-converted',
  templateUrl: './list-total-converted.component.html',
  styleUrls: ['./list-total-converted.component.css'],
})
export class ListTotalConvertedComponent implements OnInit {
  @Input() activeOrg: Organization;
  @Input() document: Document;
  @Input() property: 'total' | 'totalWithTax' = 'totalWithTax';
  @Input() showConverted = false;
  @Output() toggleShowConverted = new EventEmitter<void>();

  constructor() {}

  currency(document: Document): string {
    if (this.showConverted && document.totalWithTaxConverted) {
      return document._documentConversionRate.to;
    } else {
      return document.currencyId;
    }
  }

  currencyConverted(document: Document): string {
    if (!this.showConverted && document.totalWithTaxConverted) {
      return document._documentConversionRate.to;
    } else {
      return document.currencyId;
    }
  }

  ngOnInit() {}

  onToggleShowConverted(): void {
    this.toggleShowConverted.emit();
  }

  value(document: Document): number {
    if (this.showConverted && document[`${this.property}Converted`]) {
      return document[`${this.property}Converted`];
    } else {
      return document[this.property];
    }
  }

  valueConverted(document: Document): number {
    if (!this.showConverted && document[`${this.property}Converted`]) {
      return document[`${this.property}Converted`];
    } else {
      return document[this.property];
    }
  }
}
